module.exports = __webpack_public_path__ + "img/ETOURY.3ee33c3e.png";